import { translation } from './en';

export const caregiver = {
  'common': translation.common,
  'components': {
    ...translation.components,
    'applyToJobsWidget': {
      'title': 'Apply to jobs',
      'descriptionStart': 'Increase your chances of landing the perfect job! On the ',
      'descriptionLinkText': 'Job Board',
      'descriptionEnd': ', apply to jobs that match your schedule, skills, and experience. Expand your filters to find more options, and be sure to include a personal introduction message. Good luck!'
    },
    'approvalChecklist': {
      'heading': 'Approval Checklist',
      'purchase': 'Purchase membership',
      'tellFamilies': 'Tell families more about you',
      'backgroundCheck': 'Submit your background check',
      'backgroundCheckWaiting': 'Waiting for background check results',
      'photoGuidelines': 'Upload a photo',
      'setRates': 'Set your rates'
    },
    'articles': {
      'howItWorks': 'How babysitting works on UrbanSitter',
      'starting': 'Starting your UrbanSitter profile',
      'howToGetJobs': 'How to get jobs on UrbanSitter'
    },
    'backgroundCheckBanner': {
      'heading': 'Action Required',
      'body1': 'It\'s our policy to conduct background checks annually. It\'s time to complete yours! If your background check is not completed by ',
      'body2': ', your profile will be hidden and you will not be able to receive bookings or apply to jobs.',
      'body3': 'Please take these steps as soon as possible, as processing can take up to 4 weeks.',
      'buttonTitle': 'Submit Background Check'
    },
    'footer': {
      'aboutUs': 'About Us',
      'careers': 'Careers',
      'company': 'Company',
      'copyright': 'UrbanSitter. All Rights Reserved.',
      'discover': 'Discover',
      'explore': 'Find Schools and Groups',
      'followUs': 'Follow us:',
      'getTheApp': 'Get the App',
      'giftCards': 'Gift Cards',
      'pricing': 'Pricing',
      'privacy': 'Privacy',
      'resources': 'Childcare Resources',
      'support': 'Support',
      'terms': 'Terms of Service',
      'trustAndSafety': 'Trust and Safety'
    },
    'generalAvailability': translation.components.generalAvailability,
    'getRecommendations': {
      'heading': 'Boost your profile with reviews',
      'title': 'You\'re 2x more likely to get hired with reviews!',
      'body': 'Ask families you worked with to add a recommendation to your profile.',
      'emailSubject': 'Action requested: provide {{firstName}} a caregiver recommendation',
      'emailBody': 'Hello,%0D%0AWill you provide me a recommendation on UrbanSitter? Recommendations make it 2x more likely that I will find a job: {{url}}%0D%0A%0D%0A{{firstName}}'
    },
    'greeting': {
      'morning': 'Good morning,',
      'afternoon': 'Good afternoon,',
      'evening': 'Good evening,',
      'findJob': 'Let\'s find your next job.'
    },
    'header': {
      'hello': 'Hello',
      'logo': {
        'alt': 'UrbanSitter Home'
      },
      'mainLinks': {
        'bookings': 'Bookings',
        'calendar': 'Calendar',
        'jobBoard': 'Job board',
        'messages': 'Messages',
        'messagesUnread_one': '({{count}} unread)',
        'messagesUnread_other': '({{count}} unread)',
        'profile': 'Profile'
      },
      'mobileMenu': {
        'toggle': 'Toggle navigation menu'
      },
      'profile': {
        'account': 'Account',
        'credits': 'Credits',
        'giveFeedback': 'Give feedback',
        'logout': 'Log out >',
        'profile': 'Profile',
        'payment': 'Payment',
        'payout': 'Payout and payment',
        'settings': 'Settings',
        'successGuide': 'Success guide',
        'transactions': 'Transactions',
        'yourFamilies': 'Your families'
      }
    },
    'hiddenReasonBanner': {
      'viewApprovalChecklist': 'View approval checklist',
      'decision': {
        'heading': 'Your profile is hidden.',
        'body': 'Please contact support@urbansitter.com with questions.'
      },
      'pendingApproval': {
        'heading': 'Let\'s get your profile approved.',
        'body': 'Complete the checklist to get approved, then you can apply for jobs.'
      },
      'readyForReview': {
        'heading': 'Profile review in progress',
        'body': 'Your profile review is underway. It can take up to 48 hours. You\'ll receive an email once it\'s complete. Let\'s make your profile shine in the meantime!'
      },
      'hiddenForPhoto': {
        'heading': 'Your profile needs attention!',
        'body': 'Your profile picture could not be approved. Please update your photo according to our guidelines and request approval again.',
        'buttonTitle': 'Take me there'
      },
      'hiddenForIncompleteProfile': {
        'heading': 'Your profile needs attention!',
        'body': 'Please review each item in the checklist and request approval again.'
      },
      'unhiddenNoBookings': {
        'heading': 'You\'re approved and ready!',
        'body': 'Start applying for jobs now! A complete profile boosts your chances of getting hired. Fill out all the details to stand out!'
      }
    },
    'highlightGuide': {
      'heading': 'Let\'s do more to highlight your profile',
      'moreWays': 'More ways to help',
      'moreWaysBody': 'Which job duties are you willing to provide?',
      'additionalLanguages': 'Additional languages',
      'additionalLanguagesBody': 'Are you proficient in any of these languages?',
      'letSkillsShine': 'Let your skills shine',
      'letSkillsShineBody': 'More parents are looking for sitters to help teach their kids new skills.\n\nWhich skills are you willing to share with kids?',
      'newWays': 'New ways to work',
      'newWaysBody': 'In which situations are you willing to provide care?',
      'moreThanCare': 'More than child care',
      'moreThanCareBody': 'Families can use UrbanSitter to find care for all of their needs.\n\nAre you willing to care for:'
    },
    'jobBoard': {
      'heading': 'Job Board',
      'ctaText': 'View details',
      'seeMore': 'See all posts',
      'startingAt': 'starting\n'
    },
    'successGuide': {
      'heading': 'Success Guide',
      'body': 'Book jobs faster! Follow our guide below to stand out.',
      'headingVideo': 'Say hello in a 30 second video',
      'headingRecommendations': 'Get recommendations',
      'headingAvailability': 'Add availability to your calendar'
    }
  },
  'identityCheck': {
    'allowPopups': 'Allow popups if prompted. Having trouble? Try a new browser or device.',
    'collapse': 'Collapse',
    'expand': 'Expand',
    'facebookButton': 'Link Facebook',
    'facebookDescription': 'Alternatively, you can easily log in to Facebook to confirm your identity. Nothing will be shared or posted.',
    'facebook': {
      'headerNoStripeProgress': 'Recommended Option',
      'descriptionNoStripeProgress': "Quickly and easily log in to Facebook to confirm your identity. Nothing will be shared or posted, plus you'll see caregivers your friends book.",
      'descriptionStripeProgress': 'Alternatively, you can easily log in to Facebook to confirm your identity. Nothing will be shared or posted.',
      'verificationFailed': 'Your identity could not be verified. Please try again or contact support@urbansitter.com'
    },
    'failedAll': {
      'contact': 'Contact Support',
      'description': 'There was a problem with the information you provided.'
    },
    'description1': 'To contact providers, you need to complete a quick identity check:',
    'description2': "Securely complete an identity check with our safety partner. You'll be taken to their site.",
    'identityCheck': 'Identity check',
    'header': 'Complete Your Identity Check',
    'processing': {
      'header': 'Processing...',
      'description': "Your information has been submitted and is being processed. We'll let you know as soon as it's done. This may take a few seconds or up to two minutes.",
      'contact': "If you're continuing to receive this message longer than expected, contact",
      'refresh': 'Refresh'
    },
    'start': 'Start identity check',
    'stripeVerification': {
      'continue': 'Continue identity check',
      'verificationFailed': {
        'header': 'Your identity could not be verified. Please try again or contact support@urbansitter.com'
      },
      'notInProgress': {
        'header': 'Trust and Safety is Our #1 Priority',
        'description': 'To contact providers, you need to complete a quick identity check:'
      },
      'inProgressRequiresNoInput': {
        'header': 'Complete Your Identity Check',
        'description': 'To contact providers, you need to complete a quick identity check. Pick up where you left off!',
        'description2': "Securely complete an identity check with our safety partner. You'll be taken to their site."
      },
      'inProgressRequiresInput': {
        'header': 'Almost there...',
        'description': 'We need a bit more information to complete your identity check',
        'description2': 'Quickly and securely upload an identity document with our safety partner.'
      },
      'secondaryOption': {
        'header': 'Alternate Option',
        'description': "Answer a few questions to confirm your identity on our safety partner's website."
      },
      'upload': 'Upload with Stripe'
    },
    'verified': {
      'header': 'Success',
      'description': "Thanks for verifying your identity. You're all set to start contacting providers.",
      'continue': 'Continue'
    },
    'why': 'Why an ID check?',
    'whyDescription': 'We care about the safety of all members. Confirming your identity helps providers feel more confident in accepting jobs with you. You can also rest assured that your caregiver has completed a background check, including identity verification.'
  },
  'notifications': {
    'feedback': {
      'success': 'Thank you for your feedback!'
    },
    'genericError': 'An error occurred.',
      'credits': {
      'success': 'Credit redeemed!'
    },
    'facebook': {
      'success': 'Facebook successfully connected.',
      'error': 'Unable to link Facebook account. Please try again or contact support.'
    },
    'nps': {
      'label': 'Just now',
      'message': 'Let us know how UrbanSitter is doing.'
    }
  },
  'pages': {
    'feedback': {
      'header': 'Let us know how UrbanSitter is doing.',
      'notLikely': 'Not likely',
      'sendFeedback': 'Send feedback',
      'subheader': 'How likely is it that you would recommend UrbanSitter?',
      'veryLikely': 'Very likely'
    },
    'notifications': {
      'header': 'Notifications',
      'loading': 'Loading...',
      'emptyHeading': 'No notifications, yet',
      'emptyBodyBefore': '',
      'emptyJobBoardLink': 'Apply',
      'emptyBodyAfter': 'to jobs and receive notifications when parents want to hire you.',
      'pageOf': 'Page {{current}} of {{total}}',
      'buttons': {
        'previous': 'Previous',
        'next': 'Next'
      }
    },
    'cancelReasons': {
      'heading': "We're sorry to see you go",
      'retainAccessPrefix': 'You will retain access to your membership until',
      'retainAccessSuffix': ", the last day of your billing cycle - there are no partial refunds. After this date, you'll no longer be able to apply to jobs or receive booking requests.",
      'pleaseTellUs': 'Please tell us why',
      'chooseOrWrite': 'Please take a moment and choose from the list or write a few words to tell us why you are cancelling your membership:',
      'textareaRequired': 'Give us any additional feedback in your own words (required)',
      'textareaOptional': 'Give us any additional feedback in your own words (optional)',
      'skip': 'Skip',
      'submit': 'Submit Reason',
      'submitFailed': "Couldn't submit your reason. Try again."
    },
    'finishBackgroundCheck': {
      'mainHeading': 'Success! You purchased your membership!',
      'nextStep': 'Next step: Complete your background check',
      'preparing': 'Your personal background check form is being prepared and will be ready to complete soon.',
      'ready': "Click the button to visit our partner's site and submit your information. You will receive a badge on your profile when the background check is cleared and complete. If you are currently waiting for your profile to be approved, you will be notified of any changes or updates via email.",
      'stillPreparing': 'Your form is still being prepared. A link to complete it will appear on your dashboard once ready.',
      'stripeHeading': 'Payment Processed Successfully!',
      'paymentProcessed': 'Your payment has been successfully processed and your membership is active.',
      'stripeSeparateTab': "If you're viewing this in a separate tab, you can continue here or close it and return to the main app.",
      'finishLabel': 'Finish',
      'preparingLabel': 'Preparing...',
      'goToDashboard': 'Go to Dashboard',
      'skipForNow': 'Skip for now'
    },
    'yourFamilies': {
      'heading': 'Your Families',
      'subheading': "Families that you've worked for, been in contact with, or favorited.",
      'filters': {
        'all': 'All',
        'favorites': 'Favorites',
        'contacted': 'Contacted',
        'hidden': 'Hidden'
      },
      'empty': {
        'contacted': 'You have not been in contact with any families. Families that have booked you or sent you a message will appear here.',
        'favoritePrefix': "You haven't selected any favorites. Find your favorite families easily by clicking the heart over their photo. You can",
        'favoritePickFrom': 'select favorites',
        'favoriteAfter': 'from families that have booked or contacted you.',
        'favorite': "You haven't selected any favorites. Click the heart over a family's photo to favorite them.",
        'hidden': "Your availability is shown to all families right now. If you'd prefer not to get booking requests from a particular family you can hide your availability from them. Just select 'Hide availability' from the options menu next to that family."
      },
      'pickFromContacted': 'Select favorites from contacted families',
      'favoriteToggle': 'Toggle favorite',
      'hideToggle': 'Toggle hide availability',
      'hiddenToast': 'You hid your availability from {{name}}.',
      'removedFavoriteToast': 'You removed {{name}} from your favorites.',
      'favoriteFailed': "Couldn't update favorite. Try again.",
      'blockFailed': "Couldn't update availability. Try again.",
      'pageOf': 'Page {{current}} of {{total}}',
      'buttons': {
        'previous': 'Previous',
        'next': 'Next'
      },
      'card': {
        'viewMore': 'view more',
        'viewLess': 'view less',
        'editNote': 'Edit',
        'savePrivateNote': 'Save private note about family',
        'addBooking': 'Add a Booking',
        'showAvailability': 'Show Availability',
        'hideAvailability': 'Hide Availability',
        'report': 'Report'
      }
    },
    'credits': {
      'header': 'Redeem Credits',
      'enterVoucherToRedeem': 'Enter your promotional or gift card to redeem:',
      'voucherCode': 'Voucher Code',
      'redeem': 'Redeem',
      'activeCreditsHeader': 'Credits Available',
      'activeCreditsDescription': 'Credit will be automatically applied to all valid transactions.',
      'inactiveCreditsHeader': 'Inactive Credits',
      'creditExpires': 'Credit expires',
      'remaining': 'remaining',
      'off': 'off',
      'value': 'Value'
    },
    'creditCard': {
      'heading': 'Your credit card',
      'parentMessage': 'This card will be charged when you choose to pay caregivers via credit card. Payment for your membership plan is also billed automatically to this card.',
      'sitterMessage': 'Payment for your membership plan will be charged to this card. Your billing information is stored securely by Stripe.',
      'securedByStripe': 'Secured by Stripe',
      'termsPrefix': 'I understand and accept the',
      'termsLink': 'Payment Terms',
      'termsSuffix': '.',
      'addCta': 'Add Credit Card',
      'removeCta': 'Remove Card',
      'payoutsHeading': 'Payouts',
      'payoutsBody': 'Control how you receive funds from families for credit card bookings.',
      'managePayouts': 'Manage Payouts',
      'endingIn': 'ending in {{last4}}',
      'expirationDate': 'Expiration Date:',
      'billingZipCode': 'Billing Zip Code:',
      'verifiedOn': 'Verified on {{date}}',
      'existingMessage': 'To change your card used for payments, remove this one then add a new one.',
      'mustAgreeToTerms': 'You must agree to the Payment Terms to proceed.',
      'savedSuccess': 'Credit card saved successfully.',
      'saveError': "Couldn't save your card. Try again.",
      'removedSuccess': 'Credit card removed successfully.',
      'removeError': "Couldn't remove your card. Try again.",
      'tokenizeError': "Couldn't read your card details. Double-check and try again.",
      'confirmRemoveHeading': 'Confirm Card Removal',
      'confirmRemoveBody': 'Are you sure you want to remove this credit card?',
      'cancel': 'Cancel',
      'confirmRemove': 'Remove Card'
    },
    'sitterFriends': {
      'heading': "{{name}}'s friends who provide care ({{count}})",
      'empty': 'Sorry, {{name}} has no caregiver friends at UrbanSitter.',
      'loadMore': 'More Caregivers'
    },
    'parentProfile': {
      'toasts': {
        'linkCopied': 'Link copied to clipboard',
        'shareError': "Couldn't share. Try again.",
        'availabilityHidden': 'Availability hidden from this family.',
        'availabilityShared': 'Availability shared with this family.',
        'availabilityError': "Couldn't update availability. Try again.",
        'reportSubmitted': 'Report submitted. Thank you.',
        'removed': 'Removed.',
        'removeError': "Couldn't remove. Try again.",
        'added': 'Added.',
        'addError': "Couldn't add. Try again."
      },
      'aria': {
        'changePhoto': 'Change profile picture',
        'report': 'Report'
      },
      'tooltips': {
        'hideAvailability': "If you'd prefer not to get booking requests from this family, you can hide your availability."
      },
      'buttons': {
        'hideAvailability': 'Hide Availability'
      },
      'flagModal': {
        'title': 'Report this family',
        'inappropriateOffensive': 'This profile is inappropriate or offensive',
        'misleadingSuspicious': 'This profile is misleading or suspicious',
        'poorExperience': 'I had a poor experience with this individual',
        'discriminatory': 'This individual or their profile is discriminatory',
        'other': 'Other',
        'submit': 'Submit Report',
        'details': 'Details',
        'intro': 'Your feedback is anonymous and helps us keep the community safe.',
        'reasonRequired': 'Please choose a reason.',
        'submitError': "Couldn't submit report. Try again."
      },
      'photo': {
        'tooLarge': 'Photo must be under 10 MB.',
        'uploadFailed': "Couldn't upload photo. Try again."
      },
      'placeholders': {
        'phone': 'xxx-xxx-xxxx',
        'birthMonth': 'Birth month (1-12)',
        'birthYear': 'Birth year',
        'allergies': 'Allergies (optional)',
        'street': 'Street',
        'apt': 'Apt #',
        'city': 'City',
        'state': 'State',
        'zip': 'ZIP',
        'neighborhood': 'Neighborhood',
        'petDetails': 'Add any details such as the number, size, or personality of your pets…',
        'searchSchool': 'Search for a school',
        'searchAffiliations': 'Search affiliations',
        'searchLocalGroups': 'Search local groups',
        'searching': 'Searching…',
        'noMatches': 'No matches.'
      },
      'editKid': {
        'dependent': 'Dependent {{number}}',
        'addAnother': 'Add another dependent',
        'additionalConsiderations': 'Additional considerations',
        'emptyState': 'No dependents yet. Add one to get started.'
      },
      'sectionTitles': {
        'vaccine': 'COVID-19 Vaccine',
        'children': 'Edit dependents',
        'address': 'Home address',
        'parking': 'Parking',
        'contacts': 'Emergency contacts',
        'languages': 'Languages spoken',
        'pets': 'Pets',
        'schools': 'Schools',
        'groups': 'Groups'
      },
      'contacts': {
        'emergencyHeading': 'Emergency contact',
        'pediatricianHeading': 'Pediatrician'
      },
      'parking': {
        'hasArea': 'Is there ample parking in your area?',
        'hasSpot': 'Do you have a parking spot that the caregiver can use?'
      },
      'sections': {
        'openJobs': 'Open Job Posts',
        'badges': 'Badges',
        'noBadges': 'No badges yet.',
        'groups': 'Groups',
        'noGroups': 'No groups yet.',
        'caregiverFeedback': 'Caregiver Feedback',
        'dependents': 'Dependents',
        'ageLabel': 'Age',
        'allergiesLabel': 'Allergies',
        'homeAddress': 'Home Address',
        'neighborhoodLabel': 'Neighborhood',
        'parking': 'Parking',
        'emergencyContacts': 'Emergency Contacts',
        'languagesSpoken': 'Languages Spoken',
        'noneSpecified': 'None specified',
        'schools': 'Schools',
        'noneYet': 'None yet',
        'pets': 'Pets',
        'seeAll': 'See All',
        'notesLabel': 'Notes:'
      },
    },
    'sitterProfile': {
      'loading': 'Loading...',
      'notActive': "Sorry, this caregiver's profile is no longer active.",
      'labels': translation.components.sitterProfile.labels,
      'modals': {
        'editLanguages': 'Edit languages',
        'editTeachingSkills': 'Edit teaching skills',
        'editSpecialExperience': 'Edit special experience',
        'editSpecialServices': 'Edit special services',
        'editSpecialSituations': 'Edit special situations',
        'editOtherServices': 'Edit Other Services',
        'editRates': 'Edit rates',
        'editLocation': 'Edit location',
        'editCertifications': 'Edit certifications',
        'editEducation': 'Edit Education',
        'editAgeExperience': 'Edit your experience with different age groups',
        'covidConsent': 'COVID-19 consent',
        'availability': 'Availability',
        'jobSeekingStatus': 'Job seeking status',
        'availabilityDescAriaLabel': 'Availability status description',
        'availabilityDescPlaceholder': 'Add specific times, ideal start date, planned vacations',
        'interviewTimesAriaLabel': 'Preferred interview times',
        'interviewTimesPlaceholder': 'Add preferred interview times',
        'maxChildrenAriaLabel': 'Maximum number of children, seniors, or pets',
        'minHoursAriaLabel': 'Minimum hours per job',
        'petExperienceAriaLabel': 'Pet sitting experience',
        'petExperiencePlaceholder': 'Add any details about your pet care experience here.',
        'seniorExperienceAriaLabel': 'Senior caregiving experience',
        'seniorExperiencePlaceholder': 'Add any details about your senior care experience here.',
        'householdExperienceAriaLabel': 'Household service experience',
        'householdExperiencePlaceholder': 'Add any details about your household service experience here.',
        'placeholderStreet': 'Street',
        'placeholderApt': 'Apt #',
        'placeholderCity': 'City',
        'placeholderState': 'State',
        'placeholderZip': 'Zip Code',
        'zipAriaLabel': 'Zip Code',
        'placeholderNeighborhood': 'Add your neighborhood',
        'placeholderCollege': 'Enter your college name',
        'placeholderMajor': 'Enter your area of study / major',
        'expectedGradMonthAriaLabel': 'Expected graduation month',
        'expectedGradYearAriaLabel': 'Expected graduation year',
        'placeholderYear': 'Year',
        'jobSeekingStatusModal': {
          'whatTypeHeading': 'What type of jobs are you looking for?',
          'occasionalJobs': 'Occasional jobs',
          'partTimeJobs': 'Part-time jobs',
          'fullTimeJobs': 'Full-time jobs',
          'occasionalAvailabilityHeading': 'Availability for occasional jobs:',
          'keepCalendarCurrent': 'Keep your main calendar up to date',
          'lastUpdated': 'Last updated {{label}}',
          'moreDetailsHeading': 'More details about your availability:',
          'charactersRemaining': '{{count}} characters remaining',
          'snapshotHeading': 'Job seeking snapshot:',
          'snapshotBodyPrefix': 'Select the times you are generally available for recurring jobs on your',
          'snapshotBodyLink': 'calendar',
          'snapshotBodySuffix': '.',
          'interviewHeading': 'When are you available to interview?',
          'interviewBody': 'Suggest some good days or times. This will only display to families sending interview requests.',
          'takingBreakHeading': 'Taking a break?',
          'takingBreakBody': 'Simply uncheck the boxes above.',
          'update': 'Update',
          'loading': 'Loading',
          'amLabel': 'AM',
          'pmLabel': 'PM',
          'toggleCellAriaLabel': 'Toggle {{slot}} availability on {{day}}',
          'noAvailabilityPosted': 'No availability details posted.',
          'fullScheduleLeading': 'For the full weekly schedule,',
          'viewCalendar': 'view the calendar'
        }
      },
      'subcomponents': {
        'profileAlt': 'Profile',
        'playVideoAriaLabel': 'Play video',
        'changePhotoAriaLabel': 'Change photo',
        'editVaccineAriaLabel': 'Edit vaccine status',
        'otherServicesTitle': 'Other Services Provided',
        'shareLinkAriaLabel': 'Share link',
        'dismissAriaLabel': 'Dismiss',
        'videoProfile': 'Video Profile',
        'changePhoto': 'Change photo',
        'introduceYourself': 'Introduce yourself to families',
        'learnMore': 'Learn More',
        'seeOccasionalCalendar': 'See Occasional Calendar',
        'positiveReview': 'Positive review from you',
        'requestBooking': 'Request a Booking',
        'message': 'Message',
        'interview': 'Interview',
        'moreOptions': 'More options',
        'addNewVideo': 'Add a new video',
        'noBio': 'No bio written yet.',
        'notLookingOccasional': 'Not looking for occasional jobs',
        'notLookingJobs': 'Not looking for jobs',
        'notAcceptingFamilies': "Sorry, I'm not currently accepting new families.",
        'aboutName': 'About {{name}}'
      },
      'index': {
        'approvalChecklistLink': 'Approval checklist',
        'sectionExperience': 'Experience',
        'sectionBackground': 'Background',
        'sectionLocation': 'Location',
        'editBasicsBioTitle': 'Edit Basics and Bio',
        'editTeachingSkillsTitle': 'Edit teaching skills',
        'editSpecialExperienceTitle': 'Edit special experience',
        'editSpecialServicesTitle': 'Edit special services',
        'selectSituationsTitle': 'Select situations willing to help during',
        'editLanguagesTitle': 'Edit languages'
      },
      'availability': {
        'heading': 'Job seeking status',
        'snapshotHeading': 'Job seeking snapshot:',
        'takingBreak': 'Taking a break?',
        'updated': 'Availability updated'
      },
      'rates': translation.components.sitterProfile.rates,
      'toasts': {
        'caregiverShown': 'Caregiver shown',
        'caregiverHidden': 'Caregiver hidden',
        'visibilityError': "Couldn't update visibility.",
        'bioSaved': 'Bio saved.',
        'teachingSkillsUpdated': 'Teaching skills updated.',
        'saveError': "Couldn't save. Try again.",
        'updateError': "Couldn't update. Try again.",
        'otherServicesUpdated': 'Other services updated.',
        'ratesUpdated': 'Rates updated.',
        'locationUpdated': 'Location updated.',
        'experienceUpdated': 'Experience updated.',
        'educationUpdated': 'Education updated.',
        'educationCleared': 'Education cleared.',
        'certificationsUpdated': 'Certifications updated.',
        'favoriteError': "Couldn't update favorite. Try again."
      }
    },
    'sitterReviews': {
      'loading': 'Loading...',
      'reviewedOn': 'reviewed on {{date}}',
      'editedOn': '(edited on {{date}})',
      'reply': 'Reply',
      'edit': 'Edit',
      'response': "{{name}}'s response",
      'responseOn': "{{name}}'s response on {{date}}",
      'tabs': {
        'summary': 'Summary',
        'reviews': 'Reviews',
        'calendar': 'Calendar',
        'friends': 'Friends'
      },
      'nav': {
        'backToSearch': 'Back to search',
        'previousCaregiver': 'Previous caregiver',
        'nextCaregiver': 'Next caregiver'
      },
      'pageOf': 'Page {{current}} of {{total}}',
      'empty': '{{name}} does not have any reviews yet.',
      'headings': {
        'thanksReviewed': 'Thanks for reviewing {{name}}.',
        'pleaseReview': 'Please review {{name}}.',
        'thanksRecommended': 'Thanks for recommending {{name}}.',
        'helpRecommend': 'Help {{name}} land jobs with a recommendation.'
      },
      'buttons': {
        'editReview': 'Edit Review',
        'reviewSitter': 'Review Sitter',
        'recommend': 'Recommend',
        'previous': 'Previous',
        'next': 'Next'
      },
      'sort': {
        'ariaLabel': 'Sort reviews',
        'header': 'Sort by...',
        'byRating': { 'name': 'Highest rating', 'title': 'Sorted by highest rating' },
        'byRatingLow': { 'name': 'Lowest rating', 'title': 'Sorted by lowest rating' },
        'byMostRecent': { 'name': 'Most recent', 'title': 'Sorted by most recent' },
        'byOldest': { 'name': 'Oldest', 'title': 'Sorted by oldest' }
      }
    },
    'sitterReviewReply': {
      'heading': 'Respond to this review',
      'reviewedOn': 'reviewed on {{date}}',
      'editedOn': '(edited on {{date}})',
      'guidanceHeading': 'Your response will display on your reviews page.',
      'guidance1': 'Your response will influence other families',
      'guidance2': 'A good response is professional and thoughtful',
      'guidance3Prefix': 'Your response should follow the',
      'guidanceLink': 'Response Guidelines',
      'charactersRemaining': '{{count}} characters remaining',
      'submit': 'Submit Response',
      'saveError': "Couldn't save your response. Try again."
    },
    'rates': {
      'heading': 'What is your minimum rate?',
      'suggestionDefault': 'On average, caregivers charge ${{amount}}/hr for one {{label}}',
      'suggestionArea': 'Caregivers in your area are charging ${{amount}}/hr for one {{label}}',
      'minRateLabel': 'Minimum rate',
      'minRatePlaceholder': 'Minimum hourly rate',
      'minRateForTwo': 'Minimum rate for two {{label}}',
      'minRateForThree': 'Minimum rate for three {{label}}',
      'minRateForFour': 'Minimum rate for four {{label}}',
      'twoPlaceholder': 'Two {{label}}',
      'threePlaceholder': 'Three {{label}}',
      'fourPlaceholder': 'Four {{label}}',
      'minRate': 'Minimum rate is ${{min}}',
      'hideExtraRates': 'Hide detailed rates',
      'showExtraRates': 'Add detailed rates',
      'maxLabel': 'Max {{label}} at one time:',
      'maxPlaceholder': 'Select max to care for',
      'continue': 'Continue',
      'submitFailed': "Couldn't save your rates. Try again."
    },
    'confirm': {
      'heading': 'Confirm your information',
      'prompt': 'For security, please make sure this is your legal first and last name.',
      'emailPrompt': 'Is this the email and number you want to use?',
      'firstNameLabel': 'First Name',
      'lastNameLabel': 'Last Name',
      'emailLabel': 'Email',
      'phoneLabel': 'Phone Number',
      'firstNamePlaceholder': 'First name',
      'lastNamePlaceholder': 'Last name',
      'emailPlaceholder': 'Email address',
      'phonePlaceholder': 'xxx-xxx-xxxx',
      'firstNameRequired': 'First name is required',
      'lastNameRequired': 'Last name is required',
      'emailRequired': 'Valid email is required',
      'phoneRequired': 'Valid phone number is required',
      'continue': 'Continue',
      'submitFailed': "Couldn't save your details. Try again."
    },
    'aboutMe': {
      'heading': 'Tell families more about yourself.',
      'prompt': "What's your background? What qualifications, personality traits, and talents make you a great caregiver? Be sure to highlight your experience (kids, seniors, pets, household services).",
      'safetyPrompt': 'For your safety, avoid including your contact information. 150 characters are required.',
      'placeholder': 'Describe your relevant experience for families. At least {{min}} characters are required.',
      'charactersLeft': '{{count}} characters left',
      'minLength': '{{min}} characters minimum',
      'seeWritingIdeas': 'See Writing Ideas',
      'seeExample': 'See Example',
      'continue': 'Continue',
      'submitFailed': "Couldn't save your bio. Try again.",
      'writingPrompts': {
        'title': 'Writing Ideas',
        'heading': 'Make a great first impression by answering these questions:',
        'generalSection': 'General',
        'general1': 'Introduce yourself and share your background',
        'general2': 'What services do you offer?',
        'childCareSection': 'Child care',
        'childCare1': "What's your experience with each age group?",
        'childCare2': 'What activities do you enjoy doing with children?',
        'childCare3': 'Any special skills (tutoring, homework help, cooking) or talents (dancing, painting, etc.)?',
        'childCare4': "Any certifications or training you've received?",
        'seniorCareSection': 'Senior care',
        'seniorCare1': "What's your experience with senior care?",
        'seniorCare2': 'What non-medical skills can you offer on the job (driving, cooking, etc.)?',
        'seniorCare3': 'Why do you enjoy providing senior care?',
        'petCareSection': 'Pet care',
        'petCare1': "What's your experience with various pets and breeds?",
        'petCare2': 'What skills do you offer (walking, feeding, playing, etc.)?',
        'petCare3': 'Are you comfortable with large animals and/or animals that shed?',
        'householdSection': 'Household services',
        'household1': "What's your experience with household services?",
        'household2': 'What services do you offer (cleaning, cooking, errands, laundry, organizing, etc.)?',
        'household3': 'Can you bring your own cleaning equipment/supplies if requested?'
      },
      'example': {
        'title': 'Example',
        'name': 'About Lucy',
        'body1': "Hi - My name is Lucy and I'm currently a senior at UCLA. I am offering child care, senior care, and household services.",
        'body2': 'I love being a babysitter and have been watching newborns, infants, toddlers, and kids (including twins!) since I was 15 years old. My responsibilities have included driving to/from school, crafts, tutoring, and even dance lessons.',
        'body3': 'I also work as a household assistant and can cook, clean, and run errands.',
        'body4': 'I have been a caretaker for my own grandparents and am comfortable with senior care. I can cook, drive to appointments, or do other tasks. (I am also a great bridge partner!)',
        'body5': 'I am allergic to cats but happy to work with families with dogs.'
      }
    },
    'sitterLocation': {
      'heading': 'Find trusted jobs nearby',
      'streetLabel': 'Street',
      'streetPlaceholder': 'Street',
      'street2Label': 'Apt #',
      'street2Placeholder': 'Apt #',
      'zipLabel': 'Zip code',
      'zipPlaceholder': 'Zip',
      'cityLabel': 'City',
      'cityPlaceholder': 'City',
      'stateLabel': 'State',
      'statePlaceholder': 'State',
      'neighborhoodLabel': 'Neighborhood',
      'neighborhoodPlaceholder': 'Neighborhood (Optional)',
      'continue': 'Continue',
      'submitFailed': "Couldn't save your address. Try again.",
      'rateNegotiable': 'Rate negotiable',
      'andMore': 'And More...',
      'modalHeading': 'Just a few more steps to get started',
      'modalBody': 'Only a few more steps to complete your profile',
      'saveAndContinue': 'Save and Continue',
      'cancel': 'Cancel'
    },
    'sitterPhoto': {
      'heading': 'Select your profile photo and make a great first impression.',
      'guidelinesHeading': 'Photo Guidelines:',
      'guideline1': 'Do not select photos with other people, sunglasses, or hats.',
      'guideline2': 'Choose a close-up photo.',
      'guideline3': 'Recent photos ensure new families can recognize you.',
      'faqLink': 'View the Photo Guidelines FAQ',
      'continue': 'Continue',
      'chooseFile': 'Choose a photo',
      'uploading': 'Uploading...',
      'uploadFailed': "Couldn't upload your photo. Try again.",
      'rotate': 'Rotate',
      'zoom': 'Zoom',
      'save': 'Save',
      'cancel': 'Cancel'
    },
    'bookingDetail': {
      'loading': 'Loading...',
      'reliabilityHeading': 'Cancelation and Reliability Policy',
      'reliabilityBody': 'To protect the experiences of both families and providers, UrbanSitter Support assesses every canceled booking. We assign a status to the cancelation based on the amount of advance notice provided. If a family or provider shows a habit of canceling bookings, action may be taken on their account.',
      'readMore': 'Read more about our policies',
      'backToList': '\u2190 Back to Bookings',
      'reschedule': 'Reschedule',
      'confirmHours': 'Confirm hours',
      'acceptSuccess': 'Booking accepted.',
      'acceptError': 'Couldn\'t accept the booking. Try again.',
      'payoutModalTitle': 'Set up your payout method',
      'payoutModalBody': 'To accept credit card jobs, you need an active payout method so we know where to deposit your earnings.',
      'payoutModalCancel': 'Cancel',
      'payoutModalSetup': 'Set up payout'
    },
    'sitterBookingCreate': {
      'heading': 'Add a booking',
      'body': 'Track a job you got off-platform. UrbanSitter will log the booking but no charges will be processed.',
      'deferred': 'The detailed add-booking form still lives on the Angular page.',
      'openAngular': 'Open the add-booking form',
      'onlyForAgreed': "This is only for when you and the family have already agreed to a booking. It's not for soliciting jobs.",
      'parentNameLabel': 'Parent name',
      'parentSearchPlaceholder': 'Search by name',
      'searching': 'Searching…',
      'selectParent': 'Please select a parent.',
      'numChildrenLabel': 'Number of children',
      'ratePerHour': 'Rate per hour',
      'minRate': 'Minimum rate is $8.',
      'creditRateCap':
        'Please have parent book for credit bookings with rates greater than ${{maxRate}}.',
      'payBy': 'Pay by',
      'noCredit': 'Family has no credit',
      'payCash': 'Family pays cash/check directly',
      'useFamilyCredit': 'Use family credit',
      'locationLabel': 'Location:',
      'messageLabel': 'Message',
      'charactersRemaining': '{{count}} characters remaining',
      'continueCta': 'Continue',
      'cancel': 'Cancel',
      'addDateHeading': 'Add the date for this booking',
      'change': 'Change',
      'start': 'Start',
      'end': 'End',
      'addJob': 'Add Job',
      'bothTimesRequired': 'Please enter both start and end times.',
      'endAfterStart': 'End time must be after start time.',
      'childCount': '{{count}} child',
      'childCount_plural': '{{count}} children',
      'lastRatePaid': '(last rate paid: ${{rate}})',
      'addBookingError': "Couldn't add the booking. Try again."
    },
    'settings': {
      'loading': 'Loading...',
      'heading': 'Settings',
      'accountBasics': 'Account Basics',
      'communication': 'Communication',
      'socialConnections': 'Social Connections',
      'rowHeadings': {
        'membershipPlan': 'Membership plan',
        'nextBillingDate': 'Next Billing Date',
        'profileStatus': 'Profile status',
        'email': 'Email',
        'password': 'Password',
        'mobilePhone': 'Mobile phone',
        'notifications': 'Notifications',
        'bookingRequests': 'Booking requests',
        'newFamilies': 'New families',
        'facebook': 'Facebook',
        'google': 'Google'
      },
      'emailAriaLabel': 'Email address',
      'currentPasswordAriaLabel': 'Current password',
      'currentPasswordPlaceholder': 'Verify current password',
      'newPasswordPlaceholder': 'Enter your new password',
      'repeatPasswordPlaceholder': 'Repeat your new password',
      'cancelMembershipConfirmTitle': 'Are you sure you want to cancel your membership?',
      'name': 'Name',
      'joinedDate': 'Joined {{date}}',
      'identityCheck': 'Identity check',
      'completed': 'Completed',
      'emailLabel': 'Email',
      'passwordLabel': 'Password',
      'createPassword': 'Create Password',
      'changePassword': 'Change Password',
      'cancel': 'Cancel',
      'verifyCurrent': 'Verify current password',
      'newPassword': 'New password',
      'confirmPassword': 'Confirm new password',
      'saveChanges': 'Save Changes',
      'savedToast': 'Settings saved.',
      'saveError': "Couldn't save settings. Try again.",
      'cancelMembership': 'Cancel membership',
      'addAPlan': 'Add a plan',
      'renewMembershipPlan': 'Renew Membership Plan',
      'deactivateSuccess': 'Account deactivated.',
      'deactivateError': 'Couldn\'t deactivate your account. Try again.',
      'accountSettingsHeading': 'Account Settings',
      'deactivateHeading': 'Deactivate Account',
      'expandSection': 'Expand section',
      'collapseSection': 'Collapse section',
      'notifications': {
        'monthlyNewsletter': 'Send me monthly tips and news from UrbanSitter',
        'weeklySummary': 'Send me a weekly summary of my availability and bookings',
        'jobPostAlerts': 'Send me alerts for jobs posted within the working distance set on my profile',
        'weekendReminder': 'Remind me to confirm my weekend availability',
        'jobRequestText': 'Send a text message when a family sends me a job request',
        'interviewRequestText': 'Send a text message when a family sends me an interview request',
        'accountNotificationText': 'Send a text message with important account notifications',
        'jobApplication': 'Receive job post application notifications by default'
      },
      'bookingRequests': {
        'anyTimeSlot': 'Send interview/job requests for any time slot',
        'onlyAvailableTimes': 'Send interview/job requests only for the times I show available'
      },
      'newFamilies': {
        'notAccepting': 'Not accepting new families'
      },
      'google': {
        'linkFailed': 'Google account linking failed.',
        'linkSuccess': 'Google successfully connected.',
        'linkError': 'Couldn\'t link Google. Try again.'
      },
      'facebookSdkUnavailable': 'Facebook SDK not available. Please try again.',
      'cancelChanges': 'Cancel Changes',
      'memberSince': 'Member since {{date}}',
      'activeUntil': 'Active until {{date}}',
      'noneValue': 'None',
      'profileStatusHidden': 'Hidden',
      'profileStatusApproved': 'Approved',
      'canceled': 'Canceled',
      'updatedLine': 'Updated {{date}}',
      'cancelMembershipPlan': 'Cancel Membership Plan',
      'connectFacebook': 'Connect with Facebook',
      'facebookConnectBody': 'Connect to see recommendations from people you know.',
      'phonePlaceholder': 'xxx-xxx-xxxx',
      'phoneConsentPrefix': 'By providing your mobile phone number, you consent to UrbanSitter sending you text message communications. Your number will be shared only with families you choose to work for, and as otherwise permitted in our',
      'phoneConsentSuffix': '.',
      'cancelNow': 'Cancel Now',
      'keepMembership': 'Keep Membership',
      'cancelMembershipBody': 'Membership gives you access to all of UrbanSitter’s background check, booking, messaging, and payment tools so you can find and get paid for care jobs.'
    },
    'calendar': {
      'heading': 'Your calendar',
      'availabilityHeading': 'Availability status',
      'lookingFor': 'Looking for',
      'notLooking': 'Not currently looking',
      'lastUpdate': 'Last updated {{date}}',
      'openAngularCalendar': 'Open detailed calendar',
      'makeSureAppear': 'Make sure you appear when parents search',
      'occasionalJobs': 'Occasional jobs',
      'fullTimePartTime': 'Full-time and Part-time jobs',
      'confirmUpToDate': 'Confirm this calendar is up to date',
      'confirmedUpToDate': 'Calendar confirmed up to date.',
      'availabilityUpdated': 'Availability updated',
      'availabilityRemoved': 'Availability removed',
      'requestAvailabilityUpdated': 'Request availability updated',
      'updateError': 'Couldn\'t update. Try again.',
      'removeError': 'Couldn\'t remove. Try again.',
      'updateGeneralAvailability': 'Update general availability',
      'dragBanner': 'Click and drag the times you are available to work',
      'dismiss': 'Dismiss',
      'previous': 'Previous',
      'next': 'Next',
      'today': 'Today',
      'previousLabel': 'Previous {{unit}}',
      'nextLabel': 'Next {{unit}}',
      'unitDay': 'day',
      'unitWeek': 'week',
      'unitMonth': 'month',
      'viewDay': 'Day',
      'viewWeek': 'Week',
      'viewMonth': 'Month',
      'settingsAria': 'Calendar settings',
      'addAvailability': 'Add Availability',
      'noUpcoming': 'No upcoming availability.',
      'upcoming': 'Upcoming',
      'showMore': 'Show {{count}} more',
      'showLess': 'Show less',
      'available': 'Available',
      'availableShort': 'Avail',
      'booking': 'Booking',
      'booked': 'Booked',
      'midnightPlus': 'midnight+',
      'moreEntries': '+{{count}} more',
      'previousMonth': 'Previous month',
      'nextMonth': 'Next month',
      'timeGridAria': 'Time grid; drag to create availability',
      'goToDay': 'Go to day',
      'addOnDateAriaLabel': 'Add on {{date}}',
      'availabilityModalTitle': '{{day}} Availability',
      'fieldDate': 'Date',
      'fieldStartDate': 'Start date',
      'fieldStartTime': 'Start time',
      'fieldEndTime': 'End time',
      'fieldUntilDate': 'Until date',
      'pastMidnight': 'Willing to work past midnight',
      'applyToFutureDays': 'Apply this schedule to future {{day}}s',
      'scopeAll': 'All',
      'scopeUntil': 'Until',
      'deleteError': 'Couldn\'t delete. Try again.',
      'endBeforeStart': 'End time cannot be before start time. If you want to work past midnight, check the box below.',
      'bookingRequest': 'Booking request',
      'upcomingBooking': 'Upcoming booking',
      'profilePhotoFor': '{{name}} profile',
      'ratePerHour': '${{rate}}/hr',
      'childCount_one': '{{count}} child',
      'childCount_other': '{{count}} children',
      'kidsAgesParenthetical': '({{ages}})',
      'payVia': 'Pay via {{paymentType}}',
      'viewRequest': 'View Request',
      'viewBooking': 'View Booking',
      'allowOnlyAvailability': 'Allow families to send me booking requests only when I have availability',
      'removeAllAvailability': 'Remove all availability',
      'removeAllAvailabilityConfirm': 'Remove all availability?',
      'removeAllAvailabilityBody': 'All availability entries will be removed from your calendar.',
      'remove': 'Remove'
    },
    'jobBoard': {
      'heading': 'Find your perfect job',
      'loading': 'Loading jobs...',
      'tabs': {
        'available': 'Available jobs',
        'interested': 'Applied jobs',
        'closed': 'Closed jobs',
        'hidden': 'Hidden jobs'
      },
      'typeLabel': 'Type:',
      'distanceLabel': 'Distance:',
      'types': {
        'all': 'All Jobs',
        'occasional': 'One-Time',
        'partTime': 'Part-Time',
        'fullTime': 'Full-Time'
      },
      'distances': {
        'nearMe': 'Near me',
        '5mi': '5 miles',
        '10mi': '10 miles',
        '25mi': '25 miles',
        '50mi': '50 miles'
      },
      'moreJobs': 'More Jobs',
      'loadingMore': 'Loading...',
      'noMatchForLocation': "We're having trouble finding a match for your location",
      'noMatchBody': 'Please check back soon. Interested in browsing further? Try searching in a different location with the filters.',
      'noMatchFilters': 'No jobs match your search',
      'tryDifferent': 'Try using different filters.'
    },
    'jobDetail': {
      'heading': 'Job details',
      'loading': 'Loading job...',
      'minimumRateTooltip': "If you apply and are booked, this family's offer will meet or exceed your minimum rate.",
      'closeAriaLabel': 'Close',
      'profileWaitingTitle': 'Your profile is waiting to be approved',
      'flagContent': 'Flag content',
      'rate': 'Rate',
      'postedBy': 'Posted by {{name}}',
      'description': 'Description',
      'payment': 'Payment',
      'paymentRate': '${{rate}}/hr',
      'negotiableRate': 'Rate negotiable',
      'location': 'Location',
      'schedule': 'Schedule',
      'applied': "You've applied to this job",
      'applyNow': 'Apply',
      'applyError': "Couldn't apply. Try again.",
      'notInterested': 'Not interested',
      'hideJob': 'Hide job',
      'unhideJob': 'Unhide job',
      'returnToSearch': 'Return to search results',
      'searchForMoreJobs': 'Search for more jobs',
      'editApplication': 'Edit application',
      'reapply': 'Reapply',
      'modalQuestionTitle': '{{name}} would like you to answer these screening questions',
      'modalMessageTitle': 'Send a personal introduction to {{name}}',
      'modalMessageIntro': "Families appreciate a nice note of introduction. You might also want to explain why you're a good fit for the job or raise any concerns (parking? etc.).",
      'modalMessageLabel': 'Introduction message',
      'modalMessagePlaceholder': 'Introduce yourself to this family.',
      'modalMessageDisclaimer': 'This message will be sent with your profile. If the family wishes to request a booking, you will be notified by email. Please do not include your contact information.',
      'modalSendAnswers': 'Send Answers',
      'modalSendMessage': 'Send Message',
      'modalSkip': 'Skip'
    },
    'jobInterest': {
      'loading': 'Loading...',
      'applyError': "Couldn't apply. Try again.",
      'withdrawError': "Couldn't withdraw. Try again.",
      'applicationViewed': 'Application has been viewed',
      'applicationReceived': 'Application has been received',
      'closedStatus': 'This job is closed',
      'jobNotifications': 'Send me notifications about the status of this job application',
      'applyCta': 'Apply',
      'withdrawCta': 'Withdraw application'
    },
    'bookingConfirmHours': {
      'loading': 'Loading...',
      'heading': 'Confirm Payment Details for {{name}}',
      'prompt': 'Are you still expecting payment for the job you worked on {{date}}?',
      'tipNote': '{{name}} can add an optional tip when confirming payment.',
      'statusHeading': 'What is your current payment status?',
      'statusExpecting': 'I am expecting a payment for this job',
      'statusAlreadyPaid': "I've already been paid for this job",
      'statusCanceledBySitter': 'I did not complete this job, I canceled the booking',
      'statusCanceledByParent': 'I did not complete this job, the family canceled the booking',
      'startLabel': 'Starts',
      'endLabel': 'Ends',
      'messageTo': 'Message to {{name}} (Optional)',
      'messagePlaceholder': 'Message to {{name}}',
      'submit': 'Confirm Job Details',
      'submitting': 'Confirming...',
      'modalTitle': 'Confirm hours',
      'modalSure': 'Are you sure?',
      'modalBody': 'You are requesting to modify the hours for this job by more than 12 hours.',
      'modalYes': 'Yes, confirm hours',
      'cancel': 'Cancel',
      'submitFailed': "Couldn't confirm. Try again."
    },
    'bookingList': {
      'heading': 'Bookings',
      'subtitleSitter': 'Keep track of all your jobs and interviews. Did a family text or phone you about a job? You can add it here and get all the benefits of staying on UrbanSitter.',
      'addJob': 'Add a job.',
      'loading': 'Loading...',
      'keepOnPlatform': {
        'heading': 'Why keep jobs on UrbanSitter?',
        'peaceOfMindTitle': 'Peace of mind',
        'peaceOfMindBody': 'Our Support Team can only offer their assistance with jobs booked on UrbanSitter– handy if you ever run into a tricky payment situation.',
        'badgesTitle': 'Badges and reviews = more jobs',
        'badgesBody': 'Earn a Repeat Family badge to boost your profile. And, we automatically remind families to review you.',
        'remindersTitle': 'Reminders',
        'remindersBody': 'UrbanSitter can help both you and the family keep track of jobs and payment.',
        'addJobCta': 'Add a job'
      },
      'typeLabel': 'Type:',
      'familyLabel': 'Family:',
      'types': {
        'allActive': 'Active Bookings (by status)',
        'allDate': 'All Bookings (by date)',
        'completed': 'Completed',
        'expiredCancel': 'Expired/Closed',
        'rejected': 'Declined/Canceled',
        'pending': 'Pending'
      },
      'typeNames': {
        'allActive': 'active',
        'allDate': 'all',
        'completed': 'completed',
        'expiredCancel': 'expired/closed',
        'rejected': 'declined/canceled',
        'pending': 'pending'
      },
      'emptyTitle': "You don't have any {{filter}}bookings{{withName}}",
      'emptySitter': 'Find great jobs in the',
      'jobBoardLink': 'Job Board',
      'seeAll': 'See all bookings',
      'seeAllWithName': 'See all bookings with {{name}}',
      'noLongerActive': ' is no longer active',
      'viewDetails': 'View Details',
      'confirmJobDetails': 'Confirm job details'
    },
    'messages': {
      'heading': 'Messages',
      'loading': 'Loading...',
      'emptyHeading': 'No messages, yet',
      'emptyPrefix': 'Eager to work? Be sure to',
      'emptyJobBoardLink': 'apply to jobs',
      'emptyCalendarLink': 'add lots of availability',
      'emptyCalendarSuffix': 'to your calendar,',
      'emptyProfileLink': 'finish your profile',
      'and': 'and',
      'startConversation': 'Start a conversation...'
    },
    'messageThread': {
      'messageNameHeading': 'Message {{name}}',
      'startConversation': 'Start a conversation',
      'viewPrevious': 'View Previous Messages',
      'typeMessage': 'Type a message to {{name}}...',
      'messageLabelTo': 'Message to {{name}}',
      'sendAriaLabel': 'Send message',
      'hiddenHeading': 'Hidden Profile',
      'hiddenBody': 'Your message cannot be sent because your profile is currently hidden. Buy a membership now or email us if you have questions: support@urbansitter.com',
      'hiddenOk': 'OK',
      'planExpired': 'Your membership has expired. Go to Settings to renew.',
      'favoriteUpdateError': 'Could not update favorite.',
      'noteSaveError': "Couldn't save note.",
      'parentNoteModal': {
        'title': 'Save private note about family',
        'charactersRemaining': '{{count}} characters remaining',
        'noteAriaLabel': 'Private note',
        'privacyHint': 'This information is only visible to you'
      }
    },
    'transactions': {
      'heading': 'Transactions',
      'exportFriendly': 'Export-friendly view',
      'moreTransactions': 'More Transactions',
      'loading': 'Loading…',
      'types': {
        'booking': 'Booking Payments',
        'membership': 'Membership Fees'
      },
      'empty': {
        'sitterBooking': "When you're paid by credit card, you'll see a record of the transaction here.",
        'membership': "When you purchase a membership, you'll see a record of the fees here."
      },
      'dateNotAvailable': 'Date not available',
      'payoutNotProcessed': 'Payout not processed',
      'totalDeposited': 'Total deposited: ${{amount}}',
      'totalCharged': 'Total charged: ${{amount}}',
      'serviceTotal': 'Service total: ${{amount}}',
      'tip': 'Tip: ${{amount}}',
      'fee': 'Fee: ${{amount}}',
      'discountApplied': 'Discount Applied: -${{amount}}',
      'instantPayoutFee': 'Instant payout fee: -${{amount}}',
      'contactSupport': 'Contact support'
    },
    'videoUpload': {
      'heading': 'Say "hello" in a 30 second video',
      'prompt': 'Make a short video, so families can get to know you. Samples below.',
      'step1Heading': '1) Practice what to say',
      'step1Bullet1': '30 seconds = about 6 sentences about you',
      'step1Bullet2': 'Do NOT say your last name or contact info',
      'step2Heading': '2) Record and upload your video',
      'step2Bullet1': '2 minutes max length',
      'step2Bullet2': 'All videos are reviewed before posting',
      'step2Bullet3': 'Mac user? iMovie is your best bet',
      'step2Bullet4': 'It might be easiest to record on your phone!',
      'step3Heading': '3) Upload',
      'step3Bullet1': '2 minutes max length, almost any format works',
      'step3Bullet2': 'Click below to select your video',
      'step3Bullet3': 'All videos are reviewed before posting',
      'videoFaqPrefix': 'Get step-by-step instructions in our',
      'videoFaqLink': 'Video FAQ',
      'chooseFile': 'Select and Upload Video',
      'chooseFileMobile': 'Select or Record Video',
      'uploading': 'Uploading {{filename}}... please be patient!',
      'cancelUpload': 'Cancel Upload',
      'finishedHeading': 'Finished!',
      'finishedBody': 'Your profile video has been submitted for review.',
      'finishedBody2': "Once approved, it will display on your profile. If it doesn't meet our guidelines, you will be notified via email.",
      'toDashboard': 'Return to your dashboard',
      'toJobBoard': 'Return',
      'errorHeading': 'Something is not quite right',
      'tryAgain': 'Try another upload',
      'goToDashboard': 'Go to dashboard',
      'sampleVideosHeading': 'Sample videos from great caregivers',
      'sampleVideosBody': 'Caregivers with videos get more than twice as many jobs as those without.',
      'genericError': 'Something went wrong. Please try again.',
      'sizeLimit': 'Your video is over the 50MB limit. Try making it shorter, or recording at a lower quality.',
      'notSupported': 'Your chosen file ({{name}}) is not a supported video format. Select another video to continue.',
      'troubleOpening': "We're having trouble opening your selected file. Please ensure it's readable then try again.",
      'duplicateError': 'This video is already in our system and being reviewed.',
      'saveError': 'There was an error saving your video. Please try again.',
      'uploadError': 'Unexpected upload error. Please try again.',
      'unexpectedUploadError': 'There was an unexpected error uploading your video. Select another and try again.',
      'unexpectedProcessError': "There was an unexpected error processing your video. Ensure it's less than 2 minutes long, and try again."
    },
    'successGuide': {
      'heading': 'Success Guide',
      'approvalHeading': 'Required next steps:',
      'profileHeading': 'All-star moves:',
      'buyBackgroundCheck': 'Purchase your background check',
      'finishBackgroundCheck': 'Complete your background check form',
      'addAvailability': 'Add availability to your calendar',
      'addPayout': 'Add a payout account',
      'addVideo': 'Say hello in a 30 second video',
      'improveProfile': 'Enhance your profile',
      'getRecommendations': 'Get Recommendations',
      'copyCta': 'Copy',
      'copyInstructions': 'Copy this link to send to families.',
      'copiedToast': 'Link copied to clipboard',
      'community': {
        'title': 'The Caregiver Community',
        'joinFacebook': 'Join the facebook group'
      }
    },
    'parentFeedback': {
      'main': {
        'heading': 'Would you recommend working with {{name}} to other caregivers?',
        'subheading': 'Help keep UrbanSitter safe and trusted by providing your feedback.',
        'yesLabel': 'Yes, I would',
        'yesBody': 'I would recommend working with {{name}} and would work with them again.',
        'othersLabel': 'Not a fit for me',
        'othersBody': 'Another caregiver could be a better match for {{name}}.',
        'noneLabel': 'No caregivers should',
        'noneBody': "I don't think any caregivers should work with {{name}}.",
        'thumbsHeading': 'In your experience, does {{name}}...',
        'yesColLabel': 'Yes',
        'noColLabel': 'No',
        'respectsYourTime': 'Respect your time?',
        'accurateJobDescription': 'Accurately describe job duties?',
        'paysBasedOnBooking': 'Pay based on booking agreements?',
        'issuesMayInclude': 'Issues may include:',
        'issuesRespects1': '"No-showed" or canceled on very short notice',
        'issuesRespects2': 'Arrived home significantly late without communicating',
        'issuesAccurate1': 'More kids, pets, or seniors than listed in the booking',
        'issuesAccurate2': 'Did not describe all of the job responsibilities or skills required',
        'issuesPays1': 'Less pay than agreed upon amount',
        'issuesPays2': 'Did not pay for extra kids, pets, or seniors',
        'yesBtn': 'Yes',
        'noBtn': 'No',
        'visibilityLabel': 'Share my feedback publicly with other caregivers and {{name}}',
        'visibilitySubtext': 'Private reviews are shared only with UrbanSitter Member Services',
        'reviewFaqTitle': 'Review FAQ',
        'submit': 'Submit',
        'next': 'Next',
        'submitFailed': "Couldn't submit your review. Try again."
      },
      'safety': {
        'heading': 'Do you have a safety concern?',
        'subheading1': 'Safety is always our top priority. Do you have a concern related to this parent or job?',
        'subheading2': 'If this is an emergency, contact local authorities.',
        'yesLabel': 'Yes',
        'yesBody': 'My feedback is related to a safety concern.',
        'noLabel': 'No',
        'noBody': 'No, something else impacted my response.',
        'next': 'Next',
        'submitFailed': "Couldn't save. Try again."
      },
      'message': {
        'heading': "Is there anything else you'd like to privately share with our Member Services team about this family?",
        'placeholder': 'Optional',
        'charactersRemaining': '{{count}} characters remaining',
        'next': 'Next',
        'submitFailed': "Couldn't save your message. Try again."
      },
      'availability': {
        'heading': 'Would you like to hide your booking availability from {{name}}?',
        'subheading': 'No notification will be sent. {{name}} will not be able to send you booking requests.',
        'yesLabel': 'Yes',
        'yesBody': 'Hide my availability from this family.',
        'noLabel': 'No',
        'noBody': 'Allow this family to book me again.',
        'submit': 'Submit',
        'next': 'Next',
        'submitFailed': "Couldn't submit your review. Try again."
      },
      'success': {
        'positiveHeading': 'Success! Your feedback has been saved',
        'positiveBody': 'Thank you for making UrbanSitter a great place for caregivers.',
        'neutralHeading': 'Got it. Your feedback has been saved',
        'neutralBody1': 'Thank you for making UrbanSitter a great place for caregivers.',
        'neutralBody2': 'Our Member Services team may follow up with you if they have any questions about your reported experience.',
        'neutralBody3Prefix': 'Have questions for us? Email us at',
        'done': 'Done'
      }
    },
    'worksWith': {
      'heading': 'What services do you offer?',
      'ageSection': 'Child Care',
      'ageInstructions': 'Select the age(s) you will work with and list your years of experience.',
      'otherSection': 'More services',
      'infant': 'Infants',
      'infantRange': '(under 1 year old)',
      'toddler': 'Toddlers',
      'toddlerRange': '(1-3 years old)',
      'school': 'School age',
      'schoolRange': '(4+ years old)',
      'willSitDog': 'Pet care for dogs',
      'willSitCat': 'Pet care for cats',
      'willSitOtherPet': 'Pet care for other animals',
      'willSitSenior': 'Senior care (non-medical)',
      'willSitHome': 'Household services (cleaning, errands, house sitting, etc.)',
      'selectPlaceholder': 'Select experience',
      'continue': 'Continue',
      'submitFailed': "Couldn't save your selections. Try again."
    },
    'sitterStats': {
      'heading': 'Your Stats (last 90 days)',
      'loading': 'Loading...',
      'calculating': 'Calculating, check back soon',
      'aimForExcellent': "Aim for Excellent ratings to boost your profile's visibility and get more jobs.",
      'faqLink': 'Learn more in our Caregiver Stats FAQs',
      'bookingResponse': {
        'heading': 'Booking Response Rate',
        'pendingLink': 'Pending bookings',
        'expiredLink': 'See expired bookings',
        'haveResponse': 'have a response',
        'tipsExcellent': 'Keep up the great work! Check out these Pro Tips:',
        'tipsImprove': 'Looks like you need a little help. Here are some useful tips:',
        'tipExpiredRespond': 'If a booking expires, you can still respond by sending a message to maintain your response rate.',
        'tipDontIgnore': "Don't ignore interview requests - they could lead to your next job! Either accept or decline, but don't let requests expire.",
        'tipFollowUp': 'If an interview or job request expires, follow up with an message to the family. This helps maintain your response rate.',
        'tipItsOk': "It's ok to decline! If you explain why, families are more likely to try booking you again.",
        'tipTired': "Tired of requests when you're not available? Visit your",
        'tipTiredSettings': 'Settings',
        'tipTiredAfter': 'to select: "Send interview/job requests only for the times I show available."',
        'tipHide': 'Want to hide availability from specific families that are not a good fit? Visit the family\'s profile and select "Hide availability" in the Manage Family menu.',
        'tipVacation': 'Going on vacation?',
        'tipVacationRemove': 'Remove your availability',
        'tipVacationAnd': 'and',
        'tipVacationAdjust': 'adjust your settings',
        'tipVacationAfter': "so that families can't book you.",
        'tipDownload': 'Download the app so that you never miss a booking!'
      },
      'lastCalendarUpdate': {
        'heading': 'Last Calendar Update',
        'updateNow': 'Update now',
        'headingExcellent': "Thanks for keeping your calendar up to date. You're so organized!",
        'headingOutOfDate': 'Your calendar is out of date',
        'bodyPrefix': 'The date of your last calendar update is shown to families, and heavily influences whether they decide to contact you or not. Aim to',
        'bodyLink': 'update or confirm',
        'bodySuffix': "your calendar once a week. You'll also show up higher in search results."
      },
      'generalAvailability': {
        'heading': 'Job Seeking Status',
        'updateAvailability': 'Update now',
        'headingExcellent': "Thanks for letting families know what you're looking for!",
        'headingImprove': 'Your job seeking status is out of date',
        'body': "Your job seeking status (what you're 'looking for') influences where and how you appear in search results. Families rely on the description and the mini calendar to evaluate you as a candidate."
      },
      'concerningCancellations': {
        'headingConcerning': 'Concerning Cancelations / No Shows',
        'headingProblematic': 'Problematic Cancelations / No Shows',
        'whatsThis': "What's this?",
        'bodyExcellent': 'Thanks for standing by your commitments. Nice job!',
        'body': "We review cancelations and no-shows, taking all factors into consideration. We know some cancelations can't be avoided, but encourage all families and caregivers to stand by their commitments.",
        'bookings': 'bookings',
        'whatIsProblematic': 'What is a problematic cancelation / no show?',
        'whatIsConcerning': 'What is a concerning cancelation / no show?'
      }
    },
    'sitter': {
      'dashboard': {
        'bookings': {
          'confirmPayment': 'Confirm payment details',
          'label': 'Active bookings',
          'viewAll': 'View all bookings',
          'viewDetails': 'View details'
        },
        'joinGroupButton': 'Join the Facebook group',
        'progressList': {
          'title': 'Getting started',
          'welcome': 'Welcome!',
          'profile_approval': 'Complete approval checklist',
          'profile_reviewed': 'Profile approved',
          'start_applying': 'Start applying!'
        },
        'resources': 'Resources',
        'stats': {
          'bookingWarning': 'Respond to booking requests',
          'calendarWarning':  'Keep your calendar up to date',
          'jobSeekingWarning': 'Keep your job seeking status up to date',
          'reliabilityWarning': 'Review the reliability policy'
        }
      },
      'payout': {
        'active': {
          'acceptDepositBody1': 'Turning this feature off means families can only pay you in cash. Since many families prefer to pay via the UrbanSitter app (i.e. credit card), your job opportunities will be very limited and your profile will appear less frequently in search results.',
          'acceptDepositBody2': 'Turning this feature off does not affect your existing bookings.',
          'acceptDepositHeading': 'Accept credit card bookings',
          'body1Branch': 'When families pay by credit card, your payouts are sent through Branch. You can access funds instantly.',
          'body2Branch': 'Accepting payments through UrbanSitter means that you are eligible to work with more families!',
          'body3Branch': 'Make changes to your payout method by logging into your Branch App.',
          'declineDepositBody': 'Turn on this feature so families have the option to pay you through the UrbanSitter app (i.e. credit card). Accepting credit card payouts is free and easy to use. Your job opportunities will be very limited until you turn this feature on.',
          'declined': {
            'body1': 'Families can only pay you in cash. Since many families prefer to pay via the UrbanSitter app (i.e. credit card), your job opportunities will be very limited and your profile will appear less frequently in search results.',
            'body2': 'Bookings accepted for credit card payment prior to changing this setting will still be paid via credit card.',
            'heading': 'You are not currently accepting credit card payments through UrbanSitter'
          },
          'heading1': 'You\'re all set up! Families can pay you instantly through UrbanSitter.',
          'title': 'Booking payouts'
        },
        'backToJob': 'Back to job',
        'branchEmail': 'support@branchapp.com',
        'branchSupport': 'Branch Support',
        'branchUri': 'https://my.branchapp.com/urbansitter',
        'deactivated': {
          'body1Branch': 'Your Branch account has been deactivated. You can not accept credit card payments through UrbanSitter.',
          'body2Branch': 'Want to be eligible for jobs set to pay by credit card? Give Branch a call to reactivate your account.',
          'reactivate': 'Contact Branch'
        },
        'faqDebitCardDescription1Branch': 'Branch offers you a debit card for free that can be accessed through a digital wallet immediately. This is not a credit card.',
        'faqDebitCardDescription2Branch': 'The debit card gives you immediate access to track and spend your earnings. Plus, you\'ll get access to exclusive Branch benefits.',
        'faqDebitCardHeaderBranch': 'How can I pay with my Branch account?',
        'faqFeesDescriptionBranch': 'No! With the Branch wallet option, you keep 100% of your earnings. Prefer to be paid directly to your existing personal bank account? Link your preferred account and receive fast payouts to your own account for a small fee (min. 2% of payout or $2.99, whichever is higher).',
        'faqFeesHeader': 'Are there any fees to accept credit card payments?',
        'faqHeading': 'Credit Card Payout FAQs',
        'faqHowLongDescriptionBranch': 'Payout setup through Branch takes on average 3 minutes. With the Branch wallet option, neither your banking account nor routing information is required to complete this task.',
        'faqHowLongHeader': 'How long will payout setup take? What will I need?',
        'faqTransferDescriptionBranch': 'Yes! Link your preferred debit card and get your earnings right to your existing bank account for a fee (min. 2% of payout or $2.99, whichever is higher).',
        'faqTransferHeader': 'Can I transfer funds to my own bank account?',
        'faqWhyDescription1Branch': 'Credit card payments provide you access to 40% more job opportunities on UrbanSitter. Also, families are encouraged to tip when paying you by credit card. UrbanSitter has partnered with Branch to give you fast and easy access to your payouts.',
        'faqWhyDescription2Branch': 'The Branch team always offers payment support when you get paid by credit card.',
        'faqWhyHeader': 'Why should I accept credit card payments?',
        'faqWhyDescriptionLinkText': 'They\'re here for you if you need it!',
        'faqWhyDescriptionLinkUri': 'https://support.branchapp.com/hc/en-us',
        'ifQuestionsContact': 'If you have any questions, contact',
        'learnMore': 'Learn more',
        'legalFootnote': '*Branch is not a bank. Banking services are provided by Evolve Bank & Trust, Member FDIC.',
        'navigateToBranch': 'Navigate to Branch',
        'paymentDisabled': 'You are not eligible for credit card payments. Our records reflect that you cannot receive credit card payments at this time.',
        'paymentMethod': 'Membership payment method',
        'paymentMethodButton': 'Manage your credit card',
        'paymentMethodDescription': 'Used for purchasing and renewing your membership.',
        'payoutDescriptionBranch': 'Set up your account for fast and secure online payments. Hosted by our partner Branch. No more awkward cash exchanges. Get paid quickly for free through a Branch bank account and debit card*, or to an existing bank account for a small fee.',
        'payoutDescriptionCard': 'Earnings will be sent quickly to your personal bank account via a debit card for a small fee.',
        'payoutDescriptionWallet': 'Branch gives you free, fast access to your earnings and offers easy ways to manage your money.',
        'payoutHeading': 'Activate your payout account to get paid',
        'payoutHeadingCard': 'Direct via a debit card',
        'payoutHeadingChoose': 'Choose your payment option now:',
        'payoutHeadingWallet': 'Free to the Branch App',
        'payoutSetup': 'Set up your account',
        'securedBranch': 'Secured by Branch',
        'setupPayouts': 'Setup payouts',
        'title': 'Payout & Payment',
        'urbanSitterSupport': 'UrbanSitter Support'
      },
      'registration': {
        'availability': {
          'details': 'Providing your schedule allows us to notify you about matching job posts. This also helps families see if your schedule is a match. Deselect any availability that you can\'t work. You can customize your calendar in more detail later.',
          'deselectAny': 'Deselect any that don\'t apply',
          'fullTime': 'Full-time jobs',
          'fullTimeHours': '(more than 25 hours)',
          'generallyAvailable': 'When are you generally available?',
          'occasional': 'Occasional jobs',
          'partTime': 'Part-time jobs',
          'partTimeHours': '(25 hours or less)',
          'whatJobs': 'What jobs are you looking for?'
        },
        'next': 'Next'
      },
      'buyBackgroundCheck': {
        'leftColumn': {
          'description': 'Join and find caregiving jobs. The yearly, required membership costs a nominal amount compared to the money caregivers make on UrbanSitter.',
          'benefits': 'Membership benefits include:',
          'noOtherFees': 'No other fees. Keep 100% of every booking.',
          'background': 'A background check badge on your profile for all families to see.',
          'improved': 'Improved tooling: bookings, calendar, messaging and direct payment.',
          'assistance': 'Assistance with any booking or trust and safety issue.',
          'membershipCost': 'Membership cost:',
          'purchase': 'Purchase is non-refundable and background check is renewed yearly with membership.',
          'learnMore': 'Learn More'
        },
        'rightColumn': {
          'annualMembership': 'Annual membership',
          'todayOnlyDiscount': 'Today only discount',
          'applyDiscount': 'Apply discount',
          'total': 'Total',
          'promoCode': 'Promo code',
          'applyButton': 'Apply',
          'join': 'Join us today',
          'cardDetails': 'Card details',
          'securedBy': 'Secured by Stripe',
          'paymentText1': 'By adding your credit card above you agree to our',
          'paymentTerms': 'Payment Terms',
          'paymentText2': 'and by clicking the Purchase button, you agree to the renewal offer terms provided.',
          'skipButton': 'Skip for now',
          'purchaseButton': 'Purchase',
          'renewalTerms': 'Renewal offer terms',
          'renewalTermsDescription': 'Annual memberships continue and automatically renew for the same membership period (e.g. monthly or annually) until you cancel. Unless you cancel before your membership renews or, if you have a free trial or corporate membership, before the expiration of your free trial or corporate membership, you will be charged the then-current membership rate (which is subject to change) for your plan. You may cancel any time via your Account Settings and your cancelation will be effective at the end of your current membership term. Memberships are non-refundable.',
          'renewalTermsDescription2': 'Auto-renewal, payment, subscription, cancellation, and refund policies',
          'termsAcceptance': 'By checking this box, I confirm that I have reviewed and agree to the auto-renewal, payment, subscription, cancellation, and refund policies in UrbanSitter\'s Terms of Service.',
        },
        'messages': {
          'discountApplied': 'Discount Applied',
          'errorProcessingPayment': 'Error processing payment',
          'errorSavingCard': 'Error saving card for future use',
          'errorWithPaymentForm': 'An error occurred with the payment form',
          'errorWithPayment': 'An error occurred with the payment',
          'initializingPayment': 'Error initializing payment. Please try again.',
          'noCardReceived': 'No card received',
          'noPaymentMethodReceived': 'No payment method received',
          'paymentFailed': 'Payment Failed: Your payment could not be processed. Please try again or select a different payment method.',
          'promoCreditApplied': 'Promo credit applied!',
          'somethingWrong': 'Something went wrong. Please try again.'
        },
        'modal': {
          'terms': 'Subject to UrbanSitter, Inc.\'s Terms of Service. Discount to be used toward a single purchase of UrbanSitter Annual Sitter Membership. Restrictions include job availability and service location (not all served). Not combinable with other offers. UrbanSitter reserves the right to modify these terms.',
          'surprise': 'SURPRISE!',
          'validFor': 'Valid for 24 hours only!',
          'redeemButton': 'Redeem Now',
          'errorMessage': 'Error fetching MSA prices:'
        }
      }
    }
  },
  'validation': translation.validation,
  'verticalTypes': {
    'cat': 'Cats',
    'dog': 'Dogs',
    'home': 'Household services',
    'otherPets': 'Other pets',
    'senior': 'Senior care'
  },
}
